import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '@unified-checkout/design-system/icons/index';
import { Notification } from '@unified-checkout/design-system';
import { DeviceContext } from '../../../context/device';
import { INNER_ROUTES } from '../../../constants';

type ProfileAnnouncementProps = {
  onClose: () => void;
};

export const ProfileAnnouncement = ({ onClose }: ProfileAnnouncementProps) => {
  const navigate = useNavigate();

  const { isMobile } = useContext(DeviceContext);
  return (
    <Notification
      show
      title="Your profile is incomplete"
      hintText="Please fill in your contact details"
      hasCloseIcon
      btnsProps={[
        {
          text: 'Not now',
          size: 'md',
          variant: 'link',
          color: 'secondary',
          onClickHandler: onClose,
        },
        {
          text: 'Complete profile',
          color: 'primary',
          variant: 'link',
          onClickHandler: () => {
            navigate(INNER_ROUTES.SETTINGS);
            onClose();
          },
        },
      ]}
      icon={User}
      isMobile={isMobile}
      onCloseHandler={onClose}
    />
  );
};
